import { render, staticRenderFns } from "./fdeclaredetail.vue?vue&type=template&id=1462afce&scoped=true"
import script from "./fdeclaredetail.vue?vue&type=script&lang=js"
export * from "./fdeclaredetail.vue?vue&type=script&lang=js"
import style0 from "./fdeclaredetail.vue?vue&type=style&index=0&id=1462afce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1462afce",
  null
  
)

export default component.exports